/*
 * @Descripttion:
 * @version:
 * @Author: Mark
 * @Date: 2020-05-23 11:49:25
 * @LastEditors: dandan.Wu
 * @LastEditTime: 2021-03-29 18:31:54
 */

export const uploadFrom: UploadVideoAPI.UploadFrom = {
         video: {
           vrsId: 0,
           finsh: false,
           percent: 0,
           speed: '',
           uploadlog: '',
           status: 0,
           fileCloudId: '',
           fileName: '',
         },
         tagCategory: '',
         story: '',
         classId: '',
         actid: '',
         planid: '',
         typearea: [],
         areaid: 0,
         userclassTag: '',
         userstarTag: '',
         userclipTag: '',
         complianceStatementCode: '',
         complianceWarningCode: '',
       }

export const complianceStatementOptions = [
  { label: '含AI生成内容', value: 'AI_GENERATED' },
  { label: '含虚构演绎内容', value: 'FICTIONAL_INTERPRETATION' },
  { label: '内容含营销信息', value: 'MARKETING_INFO' },
  { label: '内容为转载', value: 'REPRINTED' },
  { label: '个人观点，仅供参考', value: 'PERSONAL_OPINION' },
  { label: '内容无需标注', value: 'NO_LABEL_REQUIRED' },
]

export const complianceWarningOptions = [
  { label: '内容可能引人不适，请谨慎观看', value: 'DISCOMFORT_WARNING' },
  { label: '内容含有高危险行为，请勿模仿', value: 'DANGEROUS_BEHAVIOR_WARNING' },
  { label: '请理性适度消费', value: 'RATIONAL_CONSUMPTION' },
  { label: '未成年人请在监护人指导下浏览', value: 'MINOR_GUARDIAN_GUIDANCE' },
  { label: '无', value: 'NONE' },
]

export const uploadChannel: UploadVideoAPI.Channel[] = [
  { text: '综艺', id: '1', disabled: false },
  { text: '电视剧', id: '2', disabled: false },
  { text: '电影', id: '3', disabled: false },
  { text: '动漫', id: '50', disabled: false },
  { text: '娱乐', id: '120', disabled: false },
  { text: '新闻', id: '106', disabled: false },
  { text: '纪录片', id: '51', disabled: false },
  { text: '音乐', id: '20', disabled: false },
  { text: '原创', id: '111', disabled: false },
  { text: '生活', id: '105', disabled: false },
  { text: '教育', id: '115', disabled: false },
  { text: '游戏', id: '116', disabled: false },
]
